import { Modal } from 'antd'

type ExistingUserModalProps = {
  open: boolean
  loading: boolean
  onOk: () => void | Promise<void>
  onCancel: () => void
}

export default function ExistingUserModal({ open, loading, onOk, onCancel }: ExistingUserModalProps) {
  return (
    <Modal
      open={open}
      onOk={() => void onOk()}
      onCancel={onCancel}
      okText="Continue"
      cancelText="Cancel"
      okButtonProps={{ loading }}
    >
      <p>
        We noticed you are an existing user. We will proceed with registering you as an Advisory Account to have
        access to multiple client accounts. Would you like to continue?
      </p>
    </Modal>
  )
}
